<template>
  <div>
    <div
      class="container d-none d-md-inline-block"
      style="margin:0px;padding:0px;width:100px;border:0;position: relative;"
    >
      <img :src="thisimagename">
      <div
        class="text-center"
        style="border: 0;position: absolute;width: 100%; height: 100%; top: 0; left:0;z-index: 10;"
      >
        <span class="small">{{ thisvalue }} / {{ thismax }}</span>
      </div>
      <!-- div :id="thisid" :class="thisvariant" class="progressinitial"></div -->
    </div>
    <div class="container d-inline-block d-md-none">
      <span class="small">{{ thisvalue }} / {{ thismax }}</span>
    </div>
  </div>
</template>
<script>
require('../assets/GDQ-svarsstapel_00.gif')
export default {
  name: 'SurveyProgressBar',
  props: {
    surveyId: {
      type: Number,
      default: 0
    },
    progressvalue: {
      type: Number,
      default: 0
    },
    progressmax: {
      type: Number,
      default: 0
    },
    progressvariant: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      thisid: this.survey_id,
      thisvalue: parseInt(this.progressvalue),
      thismax: parseInt(this.progressmax),
      thisvariant: this.progressvariant
    }
  },
  computed: {
    thisimagename: function () {
      var percent = (this.thisvalue * 100) / this.thismax
      var rounded = Math.round((percent / 10)) * 10
      var filenumber = ('00' + rounded).slice(-2)
      if (rounded === 100) {
        filenumber = 100
      }
      if (!isNaN(filenumber)) {
        return require('../assets/GDQ-svarsstapel_' + filenumber + '.gif')
      }
      return require('../assets/GDQ-svarsstapel_00.gif')
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style>
.progressinitial {
  width: 1px;
  height: 28px;
  /* -webkit-transition: width 6s; *//* For Safari 3.1 to 6.0 */
  /* transition: width 6s; */
}
</style>
